// frontend/src/i18n/en.js

/**
 * Diccionario de traducciones en inglés.
 * Clave: texto original, Valor: texto traducido en inglés.
 */
export default {
  "# Members": "# Members",
  "(provide a valid email)": "(provide a valid email)",
  "(provide a valid phone)": "(provide a valid phone)",
  "Add member": "Add member",
  "Access code": "Access code",
  "Access code not found": "Access code not found",
  "Actions": "Actions",
  "Add Member": "Add Member",
  "Age": "Age",
  "All fields are required.": "All fields are required.",
  "Another person matches the same identity fingerprint": "Another person matches the same identity fingerprint",
  "Apply": "Apply",
  "Are you sure you want to exclude": "Are you sure you want to exclude",
  "Are you sure you want to permanently delete the group": "Are you sure you want to permanently delete the group",
  "Back": "Back",
  "Back to dashboard": "Back to dashboard",
  "Back to invitations": "Back to invitations",
  "Birthdate": "Birthdate",
  "Block": "Block",
  "Blocked": "Blocked",
  "Cancel": "Cancel",
  "Change group": "Change group",
  "Clear": "Clear",
  "Close": "Close",
  "Close group": "Close group",
  "Confirm": "Confirm",
  "Confirm Deletion": "Confirm Deletion",
  "Contact": "Contact",
  "Contact name": "Contact name",
  "Contact the group leader to make changes.": "Contact the group leader to make changes.",
  "Contactable via WhatsApp": "Contactable via WhatsApp",
  "Copy link": "Copy link",
  "Could not save the changes.": "Could not save the changes.",
  "Create": "Create",
  "Create invitation": "Create invitation",
  "Create new group": "Create new group",
  "Create new invitation": "Create new invitation",
  "Created": "Created",
  "Created At (female)": "Created At",
  "Created At (male)": "Created At",
  "Creating...": "Creating...",
  "Delete": "Delete",
  "Delete Group": "Delete Group",
  "Delete invitation": "Delete invitation",
  "Edit": "Edit",
  "Edit group": "Edit group",
  "Edit group information": "Edit group information",
  "Email": "Email",
  "Email address is missing.": "Email address is missing.",
  "Email channel will be enabled only if a valid email is present.": "Email channel will be enabled only if a valid email is present.",
  "Enter": "Enter",
  "Enter access code (e.g. grp_...)": "Enter access code (e.g. grp_...)",
  "Enter it here": "Enter it here",
  "Enter phone number": "Enter phone number",
  "Error blocking group": "Error blocking group",
  "Error creating group": "Error creating group",
  "Error deleting group. Please try again.": "Error deleting group. Please try again.",
  "Error loading invitations": "Error loading invitations",
  "Error unlocking group": "Error unlocking group",
  "Error updating invitation status": "Error updating invitation status",
  "Export to Excel": "Export to Excel",
  "Failed to create invitation.": "Failed to create invitation.",
  "Failed to create member": "Failed to create member",
  "Failed to send magic link. Please try again.": "Failed to send magic link. Please try again.",
  "Female": "Female",
  "Filters": "Filters",
  "Filters applied": "Filters applied",
  "First / Middle Name": "First / Middle Name",
  "First Name": "First Name",
  "Full Last Name": "Full Last Name",
  "Full Name": "Full Name",
  "Gender": "Gender",
  "Group Access": "Group Access",
  "Group Invitations": "Group Invitations",
  "Group Name": "Group Name",
  "Group owner": "Group owner",
  "Have an access code instead?": "Have an access code instead?",
  "Have an account?": "Have an account?",
  "Hash": "Hash",
  "In the form, use the authentication code you received.": "In the form, use the authentication code you received.",
  "internal": "internal",
  "Invalid credentials": "Invalid credentials",
  "Invalid email format.": "Invalid email format.",
  "Invalid hash": "Invalid hash",
  "Invalid or expired link. Please try again.": "Invalid or expired link. Please try again.",
  "Invalid or mismatched data.": "Invalid or mismatched data.",
  "Invalid or unauthorized hash": "Invalid or unauthorized hash",
  "Invitation created and email sent.": "Invitation created and email sent.",
  "Invitation email sent successfully": "Invitation email sent successfully",
  "Last Name": "Last Name",
  "Last Name(s)": "Last Name(s)",
  "Lock group": "Lock group",
  "Log in": "Log in",
  "Login": "Login",
  "Logout": "Logout",
  "Loading members...": "Loading members...",
  "Access link sent. Tell the group owner to check their email.": "Access link sent. Tell the group owner to check their email.",
  "Male": "Male",
  "Manage Members": "Manage Members",
  "Middle Name": "Middle Name",
  "My Groups": "My Groups",
  "Name": "Name",
  "Name is required and at least one contact method (phone or email) is required.": "Name is required and at least one contact method (phone or email) is required.",
  "National ID": "National ID",
  "Nationality": "Nationality",
  "Next": "Next",
  "No active session": "No active session",
  "No name": "No name",
  "No phone": "No phone",
  "Notify by email": "Notify by email",
  "Notify by WhatsApp": "Notify by WhatsApp",
  "Only Dominican ID numbers are accepted. They must contain exactly 11 digits and pass the official checksum validation. If this is not possible, please use a valid passport instead.": "Only Dominican ID numbers are accepted. They must contain exactly 11 digits and pass the official checksum validation. If this is not possible, please use a valid passport instead.",
  "Or, receive an access link via email:": "Or, receive an access link via email:",
  "Page": "Page",
  "Passport": "Passport",
  "Person already registered in this group": "Person already registered in this group",
  "Phone": "Phone",
  "Phone must contain at least 7 digits.": "Phone must contain at least 7 digits.",
  "Please check the format and try again": "Please check the format and try again",
  "Please enter a valid phone number.": "Please enter a valid phone number.",
  "Please enter your access code": "Please enter your access code",
  "Please enter your email or phone": "Please enter your email or phone",
  "Prev": "Prev",
  "Reactivate": "Reactivate",
  "Recipient": "Recipient",
  "Reopen group": "Reopen group",
  "Resend email": "Resend email",
  "Resend invitation email": "Resend invitation email",
  "Responsible": "Responsible",
  "Responsible Email": "Responsible Email",
  "Responsible Name": "Responsible Name",
  "Responsible Phone": "Responsible Phone",
  "Revoke Invitation": "Revoke Invitation",
  "Revoked": "Revoked",
  "Save": "Save",
  "Second Last Name": "Second Last Name",
  "Send a copy to the leader": "Send a copy to the leader",
  "Send Magic Link": "Send Magic Link",
  "Sign in here": "Sign in here",
  "Status": "Status",
  "Switch to dark mode": "Switch to dark mode",
  "Switch to English": "Switch to English",
  "Switch to light mode": "Switch to light mode",
  "Switch to Spanish": "Cambiar a Español",
  "The country configuration is missing. Please contact support or your system administrator.": "The country configuration is missing. Please contact support or your system administrator.",
  "This action is irreversible and will delete all its members and invitations.": "This action is irreversible and will delete all its members and invitations.",
  "This age exceeds contractual policies.": "This age exceeds contractual policies.",
  "This field is required.": "This field is required.",
  "This group is closed.": "This group is closed.",
  "This group is in read-only mode.": "This group is in read-only mode.",
  "To delete this invitation permanently, type": "To delete this invitation permanently, type",
  "Token not provided. Redirecting...": "Token not provided. Redirecting...",
  "Total Groups": "Total Groups",
  "Total Members": "Total Members",
  "Total People": "Total People",
  "Travel Group": "Travel Group",
  "Unable to load your groups.": "Unable to load your groups.",
  "Unblock": "Unblock",
  "Unexpected error during access verification": "Unexpected error during access verification",
  "Unexpected error. Please try again": "Unexpected error. Please try again",
  "Unknown error.": "Unknown error.",
  "Unnamed group": "Grupo sin nombre",
  "Validating...": "Validating...",
  "Validating your access link...": "Validating your access link...",
  "Verified member — Editing is restricted (only Contact & Passport).": "Verified member — Editing is restricted (only Contact & Passport).",  
  "View members": "View members",
  "WhatsApp channel will be enabled only if a valid phone is present.": "WhatsApp channel will be enabled only if a valid phone is present.",
  "Yes, Delete": "Yes, Delete",
  "You must enter the group name and phone number.": "You must enter the group name and phone number.",
  "You will be redirected shortly.": "You will be redirected shortly.",
  "Your email or phone": "Your email or phone",
  "active": "active",
  "active (female)": "active",
  "active (male)": "active",
  "blocked": "blocked",
  "blocked (female)": "blocked",
  "blocked (male)": "blocked",
  "closed": "closed",
  "closed (female)": "closed",
  "closed (male)": "closed",
  "from the group?": "from the group?",
  "null": "n/a",
  "null (female)": "n/a",
  "null (male)": "n/a",
  "of": "of",
  "pending (male)": "pending",
  "revoked": "revoked",
  "revoked (female)": "revoked",
  "revoked (male)": "revoked",
  "years": "years",
  "yrs": "yrs",
  "{{count}} member": "{{count}} member",
  "{{count}} members": "{{count}} members"
}
